/* Home — A day with Dozzee: stars, stacked-card scale/dim, background day→night. */
(function () {
  var TYPE = 'home-day';

  function stars(root) {
    var box = root.querySelector('[data-stars]');
    if (!box || box.childElementCount) return;
    var html = '';
    for (var i = 0; i < 36; i++) {
      var r = function (n) { var x = Math.sin(i * 12.9898 + n * 78.233) * 43758.5453; return x - Math.floor(x); };
      var sz = (2 + r(3) * 3).toFixed(1) + 'px';
      html += '<span style="left:' + (r(1) * 100).toFixed(2) + '%;top:' + (r(2) * 72).toFixed(2) + '%;width:' + sz + ';height:' + sz + ';opacity:' + (0.35 + r(4) * 0.65).toFixed(2) + '"></span>';
    }
    box.innerHTML = html;
  }

  function init(root) {
    if (!root || root._hd) return;
    root._hd = true;
    stars(root);
    var D = window.Dozzee || {};
    if (!D.gsap || D.reduce) return;
    D.gsap(function (gsap) {
      if (!root.isConnected) return;
      root._ctx = gsap.context(function () {
        var cards = Array.prototype.slice.call(root.querySelectorAll('[data-card]'));
        cards.forEach(function (card, i) {
          var next = cards[i + 1];
          if (!next) return;
          var st = { trigger: next, start: 'top bottom', end: 'top 150px', scrub: true };
          gsap.to(card, { scale: 0.92, ease: 'none', scrollTrigger: st });
          var dim = card.querySelector('[data-card-dim]');
          if (dim) gsap.to(dim, { opacity: 0.45, ease: 'none', scrollTrigger: { trigger: next, start: 'top bottom', end: 'top 150px', scrub: true } });
        });
        gsap.timeline({ scrollTrigger: { trigger: root.querySelector('[data-cards]'), start: 'top 60%', end: 'bottom bottom', scrub: true } })
          .to(root, { backgroundColor: '#ECE7D9', duration: 1, ease: 'none' })
          .to(root, { backgroundColor: '#E6E1D2', duration: 1, ease: 'none' })
          .to(root, { backgroundColor: '#26301F', duration: 1.2, ease: 'none' })
          .to(root.querySelector('[data-sky]'), { opacity: 1, duration: 0.6 }, '-=0.5');
      }, root);
    });
  }

  function all(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-section-type="' + TYPE + '"]'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); });
  else all();
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll('[data-section-type="' + TYPE + '"]'), function (r) { if (r._ctx) r._ctx.revert(); });
  });
})();
